// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  z-index: 11;
  flex-direction: row-reverse; /* Mueve el logo a la derecha */
}
  
  .header-logo {
    height: 40px;
    margin-top: 12px;
    margin-left: 5px;
  }
  
  .menu-button {
    display: none;
    font-size: 2rem;
    background: none;
    border: none;
    cursor: pointer;
  }
  
  .header-nav {
    display: none; /* Ocultar navegación por defecto */
  }
  
  .header-link {
    margin-left: 20px;
    text-decoration: none;
    color: inherit;
    font-size: 1rem;
  }
  
  @media (max-width: 768px) {
    .menu-button {
      display: block;
      color: #000;
      position: fixed;
      top: 15px;
      right: 15px;
      font-size: 24px;
      background: none;
      border: none;
      cursor: pointer;
      z-index: 1001; /* Asegurarse de que el botón esté por encima del menú desplegable */
    }
  
    .header-nav {
      display: flex;
      flex-direction: column;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: white;
      justify-content: center;
      align-items: center;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s ease-in-out;
      z-index: 1000;
    }
  
    .header-nav.open {
      opacity: 1;
      pointer-events: auto;
    }
  
    .header-link {
      margin: 20px 0;
      font-size: 1.5rem;
      color: #000;
      text-decoration: none;
      transition: color 0.3s ease;
    }
  
    .header-link:hover {
      color: #007bff; /* Cambiar color al pasar el cursor */
    }
  
    .header {
      position: relative;
      z-index: 1000; /* Asegurarse de que el header esté por encima del contenido principal */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,2BAA2B,EAAE,+BAA+B;AAC9D;;EAEE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa,EAAE,mCAAmC;EACpD;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE;MACE,cAAc;MACd,WAAW;MACX,eAAe;MACf,SAAS;MACT,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,aAAa,EAAE,oEAAoE;IACrF;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,eAAe;MACf,MAAM;MACN,OAAO;MACP,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,uBAAuB;MACvB,mBAAmB;MACnB,UAAU;MACV,oBAAoB;MACpB,oCAAoC;MACpC,aAAa;IACf;;IAEA;MACE,UAAU;MACV,oBAAoB;IACtB;;IAEA;MACE,cAAc;MACd,iBAAiB;MACjB,WAAW;MACX,qBAAqB;MACrB,2BAA2B;IAC7B;;IAEA;MACE,cAAc,EAAE,qCAAqC;IACvD;;IAEA;MACE,kBAAkB;MAClB,aAAa,EAAE,wEAAwE;IACzF;EACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  z-index: 11;\n  flex-direction: row-reverse; /* Mueve el logo a la derecha */\n}\n  \n  .header-logo {\n    height: 40px;\n    margin-top: 12px;\n    margin-left: 5px;\n  }\n  \n  .menu-button {\n    display: none;\n    font-size: 2rem;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n  \n  .header-nav {\n    display: none; /* Ocultar navegación por defecto */\n  }\n  \n  .header-link {\n    margin-left: 20px;\n    text-decoration: none;\n    color: inherit;\n    font-size: 1rem;\n  }\n  \n  @media (max-width: 768px) {\n    .menu-button {\n      display: block;\n      color: #000;\n      position: fixed;\n      top: 15px;\n      right: 15px;\n      font-size: 24px;\n      background: none;\n      border: none;\n      cursor: pointer;\n      z-index: 1001; /* Asegurarse de que el botón esté por encima del menú desplegable */\n    }\n  \n    .header-nav {\n      display: flex;\n      flex-direction: column;\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: white;\n      justify-content: center;\n      align-items: center;\n      opacity: 0;\n      pointer-events: none;\n      transition: opacity 0.3s ease-in-out;\n      z-index: 1000;\n    }\n  \n    .header-nav.open {\n      opacity: 1;\n      pointer-events: auto;\n    }\n  \n    .header-link {\n      margin: 20px 0;\n      font-size: 1.5rem;\n      color: #000;\n      text-decoration: none;\n      transition: color 0.3s ease;\n    }\n  \n    .header-link:hover {\n      color: #007bff; /* Cambiar color al pasar el cursor */\n    }\n  \n    .header {\n      position: relative;\n      z-index: 1000; /* Asegurarse de que el header esté por encima del contenido principal */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
